import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["name", "labelText", "options", "onSelectOptionCallback"];
import React from 'react';
import { StyledDropdown as CheggUiDropdown } from './styled';
import { FastField } from 'formik';
import { useInitialOrDefaultFieldValue } from '../../hooks/useInitialOrDefaultFieldValue';
var getDefaultOptionValue = function getDefaultOptionValue(options) {
  return _typeof(options[0]) === 'object' ? options[0].value : options[0];
};
export var Dropdown = function Dropdown(_ref) {
  var name = _ref.name,
    labelText = _ref.labelText,
    options = _ref.options,
    onSelectOptionCallback = _ref.onSelectOptionCallback,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var value = getDefaultOptionValue(options);
  useInitialOrDefaultFieldValue(name, value);
  return /*#__PURE__*/React.createElement(FastField, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    return /*#__PURE__*/React.createElement(CheggUiDropdown, _extends({}, restProps, {
      inputId: name,
      labelText: labelText,
      options: options,
      value: field.value || value,
      onSelectValue: function onSelectValue(value) {
        form.setFieldValue(name, value);
        onSelectOptionCallback && onSelectOptionCallback({
          value: value,
          form: form
        });
      }
    }));
  });
};